<template>
  <article class="search-result-imagen flex-col md:flex-row">
    <figure
      class="responsive-image rounded-sm no-overflow bg-gray-200"
      v-html="item.media_image"
    ></figure>
    <div>
      <h3 class="my-md md:mt-0 md:mb-md text-base">
        <a
          :href="url"
          @click="sendEvent('click', item, 'Global Search Image Result Clicked')"
          class="c-black hover:c-blue-400"
        >
          <ais-highlight :hit="item" attribute="media_title" />
        </a>
      </h3>
      <p v-if="item.media_variation_titles" class="text-sm c-gray-800">
        {{
          Array.isArray(item.media_variation_titles)
          ? item.media_variation_titles.join(', ')
          : item.media_variation_titles
        }}
      </p>
    </div>
  </article>
</template>

<script>
import {getImageLibraryUrl} from '../../main/utils';

export default {
  props: ['item', 'sendEvent'],
  computed: {
    url() {
      return getImageLibraryUrl(this.item.media_id);
    }
  }
};
</script>

<style lang="scss">
@import '../../../scss/system';
@import '../../../scss/mixins';

.search-result-imagen {
  @media (min-width: 1024px) {
    figure {
      width: 33%;
      max-width: 190px;
      max-height: 115px;
      margin-right: 1.25em;
      flex-shrink: 0;
    }
  }
}
</style>
